"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.Context = React.createContext({
    clickAndCollect: null,
});
//# sourceMappingURL=context.js.map